import React, { useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { border, borderRadius, styled } from "@mui/system";
import "../../../style/style.css";
import ReactPlayer from "react-player";
import Slider from "react-slick";
import slider1 from '../../../style/images/left-1.png'
import slider2 from '../../../style/images/left-2.png'
import slider3 from '../../../style/images/left-3.png'
import slider4 from '../../../style/images/left-4.png'
import slider5 from '../../../style/images/left-5.png'
// import slider5 from '../../../style/images/slider5.png'
// import slider6 from '../../../style/images/slider6.png'
import bg from '../../../style/images/backgound.png'
import logoNew from '../../../commom/Assets/images/LogoNew.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function LeftSide() {

  // Environment storing
  const [selectedEnvironment, setSelectedEnvironment] = useState(
    localStorage.getItem("selectedEnvironment") || "DEV"
  );

  // Slider state
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (!localStorage.getItem("selectedEnvironment")) {
      localStorage.setItem("selectedEnvironment", "DEV");
      setSelectedEnvironment("DEV")
    }

  }, []);

  const handleEnvironmentChange = (event) => {
    const value = event.target.value;
    setSelectedEnvironment(value);
    localStorage.setItem("selectedEnvironment", value);
    window.location.reload()

  };

  const totalcards = [
    {
      heading: "Booster",
      heading2: "Loans",
      src: slider5,
      description:
        "Our exclusive Booster Loans give eligible investors access to addintion buying power for crypto investments."

    },
    {
      heading: "Instant",
      heading2: "Approvals",
      src: slider4,
      description:
        "Access additional buying power through Wolfpack's real-time eligibility engine and receive approval in minutes."
    },
    {
      heading: "Flexible",
      heading2: "Repayments",
      src: slider3,
      description:
        "Repay your Booster Loan over 10 weeks with a fixed repayment schedule designed to fit your budget and investment goals."
    },
    {
      heading: "Mr Wolf",
      heading2: "AI Assistant",
      src: slider1,
      description:
        "Discover crypto opportunities that match your interests, market trends and investing preferences."
    },
    {
      heading: "Trade",
      heading2: "Anywhere",
      src: slider2,
      description: "Access your portfolio wherever you are and stay connected to the market across desktop and mobile."
    },
  ];
  const settings = {
    dots: true, // Show dots for navigation
    infinite: true, // Infinite looping
    speed: 500, // Transition speed in milliseconds
    slidesToShow: 1, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    autoplay: true,
    autoplaySpeed: 4000, // Auto-play interval in milliseconds (slowed down)
    pauseOnHover: true, // Pause auto-play on hover
    arrows: false, // Hide arrows for cleaner look
    beforeChange: (current: number, next: number) => setCurrentSlide(next),
    customPaging: (i: number) => (
      <div
        style={{
          width: '24px',
          height: '4px',
          borderRadius: '2px',
          backgroundColor: i === currentSlide ? '#F2674A' : 'rgba(255, 255, 255, 0.3)',
          margin: '0 4px',
          transition: 'all 0.3s ease'
        }}
      />
    ),
  };


  return (
    <LeftSection className="LeftSection h-100">



      <Box
        className="logo"
        zIndex={2}
        gap={2}
        // marginBottom='40px'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Center the logo
          gap: '12px'
        }}
      >
        <img
          src={logoNew}
          alt="Wolfpack Logo"
          style={{
            height: "48px",
            width: "auto",
            objectFit: "contain",
            maxWidth: "200px"
          }}
        />
      </Box>
      {/* 
        <ReactPlayer
          url="https://vimeo.com/651107333"
          playing
          loop
          muted
         
          style={{border:'5px solid #141414', maxWidth: '100%', maxHeight: '397px', margin:'0 auto', borderRadius:'20px', overflow:'hidden'}}
          // sx={{borderRadius:'20px', border:'1px solid white'}}
        /> */}
      {/* <video width="640" height="360" loop autoPlay muted style={{position:'relative', height:'auto', border:'5px solid #141414', borderRadius:'20px'}} >
        <source src={video} type="video/mp4"/>
          Your browser does not support the video tag.
      </video>

      <Typography mt='50px' variant="h3" textAlign='center' zIndex={2} className="Typography fw-700 heading">
        Welcome to the
        Future of Investing
      </Typography> */}
      {/* <CCarousel  indicators interval={300} controls> */}
      <Box sx={{
        zIndex: 2,
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 0', // Further reduced padding
        minHeight: '280px' // Much smaller height to match Figma
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: {
            xs: '280px',   // Mobile
            sm: '300px',   // Small tablets
            md: '300px',   // Tablets
            lg: '840px',   // Laptops (1440px)
            xl: '840px',   // Large screens (1920px)
            xxl: '880px'   // Very large screens (2560px+)
          },
          height: 'auto',
          position: 'relative',
          '& .slick-slider': {
            position: 'relative',
            display: 'block'
          },
          '& .slick-list': {
            position: 'relative',
            display: 'block',
            overflow: 'hidden'
          },
          '& .slick-track': {
            position: 'relative',
            display: 'block'
          }
        }}>
          <Slider {...settings}>
            {totalcards.map((card, index) => (
              <Box
                display="flex"
                key={index}
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap="12px" // Further reduced for compact design
                sx={{
                  padding: { xs: '10px', sm: '15px', md: '20px' }, // More compact padding
                  minHeight: '280px' // Much smaller height to match Figma
                }}
              >
                <img
                  src={card.src}
                  alt=""
                  style={{
                    flex: 1,
                    margin: "auto",
                    // width: "100%",
                    maxHeight: '47vh',
                    // maxWidth: "320px", // Even smaller to match Figma
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "12px",
                  }}
                  className="slider-image"
                />
                {/* <Typography
                  className="text-white"
                  sx={{
                    fontSize: {
                      xs: "18px",
                      sm: "20px",
                      md: "22px",
                      lg: "24px",
                      xl: "26px",
                      xxl: "31px"
                    },
                    fontWeight: "bold",
                    textAlign: "center",
                    lineHeight: 1.2,
                    maxWidth: "90%",
                    margin: "0 auto",
                    marginTop: "16px"
                  }}
                >
                  {card.heading}
                </Typography> */}
                <Box className='mx-auto d-flex flex-column align-items-center'>
                  <Typography fontSize={'54px'} className="fw-bold m-0 p-0" lineHeight={'1'}>{card.heading}</Typography>
                  <Typography fontSize={'54px'} className="fw-bold gradient-text m-0 p-0" lineHeight={'1'} style={{ width: "fit-content" }}>{card.heading2}</Typography>
                </Box>
                <Typography
                  className="text-center"
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "14px",
                      lg: "15px",
                      xl: "20px",
                      xxl: "26px"
                    },
                    lineHeight: 1.4,
                    maxWidth: "50%",
                    margin: "0 auto",
                    marginTop: "8px",
                    opacity: 0.9
                  }}
                >
                  {card.description}
                </Typography>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
      {/* Radio button for the environment - HIDDEN FOR NOW */}
      {/* <FormControl 
        className="text-white" 
        component="fieldset" 
        sx={{ 
          mt: 3, 
          zIndex: 2,
          '& .MuiFormLabel-root': {
            color: 'white',
            fontSize: '14px',
            fontWeight: 500
          },
          '& .MuiFormControlLabel-label': {
            color: 'white',
            fontSize: '14px'
          }
        }}
      >
        Environment :
        <RadioGroup
          name="environment-selection"
          sx={{ flexDirection: "row", mt: 1, gap: 1 }}
          value={selectedEnvironment}
          onChange={handleEnvironmentChange}
        >
          <FormControlLabel value="DEV" control={<Radio sx={{ color: 'white' }} />} label="DEV" />
          <FormControlLabel value="PROD" control={<Radio sx={{ color: 'white' }} />} label="PROD" />
        </RadioGroup>
      </FormControl> */}

    </LeftSection>
  );
}

export default LeftSide;
const LeftSection = styled(Box)(({ theme }) => ({
  width: "100%",
  height: '100vh',
  display: "flex",
  overflow: 'hidden',
  // background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${bg})`,
  // backgroundPosition: 'center center',
  // backgroundSize: 'cover',
  // backgroundRepeat: 'no-repeat',
  background: "#000000",
  flexDirection: "column",
  justifyContent: "space-between",
  textAlign: "start",
  position: 'relative',
  padding: '40px',
  color: "white",
  fontWeight: 'bold',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // background: 'rgba(0, 0, 0, 0.7)', // 70% opacity overlay (30% image visibility)
    zIndex: 1,
  },
  // Hide for screens smaller than 1024px specifically
  '@media (max-width: 1023px)': {
    display: "none",
  },
  [theme.breakpoints.up("lg")]: {
    padding: '45px', // Slightly reduced for 1440px screens
  },
  [theme.breakpoints.up("xl")]: {
    padding: '60px',
  },
  // Specific styling for 1440px screens
  '@media (min-width: 1440px) and (max-width: 1600px)': {
    padding: '35px',
  },
}));
